import React from 'react';
import { Badge } from './ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { getStatusBadge } from './dashboardUtils';
import { Car } from 'lucide-react';

const VehicleHistoryModal = ({ vehicleHistory, open, onClose }) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-gray-900 border-gray-700 max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <Car className="h-5 w-5 text-brand" />
            Araç Geçmişi - {vehicleHistory?.vehicle?.plate}
          </DialogTitle>
        </DialogHeader>
        {vehicleHistory && (
          <div className="space-y-4">
            <div className="grid grid-cols-3 gap-2 text-center">
              <div className="bg-gray-800 rounded-lg p-3"><p className="text-gray-400 text-xs">Toplam İş</p><p className="text-white font-bold text-xl">{vehicleHistory.totalJobs}</p></div>
              <div className="bg-gray-800 rounded-lg p-3"><p className="text-gray-400 text-xs">Toplam Tutar</p><p className="text-brand font-bold text-xl">{vehicleHistory.totalSpent?.toLocaleString()} TL</p></div>
              <div className="bg-gray-800 rounded-lg p-3"><p className="text-gray-400 text-xs">Ödenen</p><p className="text-green-400 font-bold text-xl">{vehicleHistory.totalPaid?.toLocaleString()} TL</p></div>
            </div>
            {vehicleHistory.customer && (
              <div className="bg-gray-800/60 rounded-lg p-3 border border-gray-700/40">
                <p className="text-white font-semibold text-sm">{vehicleHistory.customer.name}</p>
                <p className="text-gray-400 text-xs">{vehicleHistory.customer.phone} | {vehicleHistory.customer.email}</p>
              </div>
            )}
            {vehicleHistory.activeJob && (
              <div className="bg-blue-900/20 border border-blue-700/40 rounded-lg p-3">
                <p className="text-blue-400 font-semibold text-sm mb-1">Aktif İş</p>
                <div className="flex items-center gap-2">
                  {getStatusBadge(vehicleHistory.activeJob.status)}
                  <span className="text-white text-sm">{(vehicleHistory.activeJob.services || []).join(', ')}</span>
                </div>
              </div>
            )}
            <div>
              <h4 className="text-white font-semibold text-sm mb-2">Servis Geçmişi</h4>
              {vehicleHistory.jobs?.map(j => (
                <div key={j.id} className="bg-gray-800/60 border border-gray-700/40 rounded-lg p-3 mb-2">
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="flex items-center gap-2 mb-1">{getStatusBadge(j.status)}</div>
                      <div className="flex flex-wrap gap-1">
                        {(j.services || []).map((s, i) => <Badge key={`vh-svc-${s}-${i}`} variant="outline" className="border-gray-600 text-gray-300 text-xs">{s}</Badge>)}
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-white font-bold text-sm">{j.totalPrice} TL</p>
                      <p className="text-gray-400 text-xs">{j.startDate ? new Date(j.startDate).toLocaleDateString('tr-TR') : ''}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {vehicleHistory.inspections?.length > 0 && (
              <div>
                <h4 className="text-white font-semibold text-sm mb-2">Muayene Kayıtları ({vehicleHistory.inspections.length})</h4>
                {vehicleHistory.inspections.map((insp, i) => (
                  <div key={insp.id || `insp-${i}`} className="bg-gray-800/60 border border-gray-700/40 rounded-lg p-3 mb-2 text-xs">
                    <div className="grid grid-cols-3 gap-2">
                      {insp.mileage && <div><span className="text-gray-400">KM:</span> <span className="text-white">{insp.mileage?.toLocaleString()}</span></div>}
                      {insp.fuelLevel && <div><span className="text-gray-400">Yakıt:</span> <span className="text-white">{insp.fuelLevel}</span></div>}
                      <div><span className="text-gray-400">Boya:</span> <span className="text-white">{insp.paintCondition}</span></div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default VehicleHistoryModal;
